import { render, staticRenderFns } from "./listcategory.vue?vue&type=template&id=43fb31ea"
import script from "./listcategory.vue?vue&type=script&lang=js"
export * from "./listcategory.vue?vue&type=script&lang=js"
import style0 from "./listcategory.vue?vue&type=style&index=0&id=43fb31ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports